import { render, staticRenderFns } from "./SegmentedTrendsDateLabel.vue?vue&type=template&id=4225ab45&scoped=true"
import script from "./SegmentedTrendsDateLabel.vue?vue&type=script&lang=ts"
export * from "./SegmentedTrendsDateLabel.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedTrendsDateLabel.vue?vue&type=style&index=0&id=4225ab45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225ab45",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/segmented-trends/segmented-trends-date-label.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsegmented-trends%2FSegmentedTrendsDateLabel.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports